import styled from 'styled-components'
import { createCardLayoutStyles } from '~/pages/anatomy/quizBinaryChoice/libs/styles/cardLayout'
import { COLORS } from '~/shared/constants/uiConstants'

export const Styles = createCardLayoutStyles({
  secondBehind: '#ffd387',
  firstBehind: COLORS.PURPLE_100,
  front: '#fdfcf7',
})

export const Image = styled.img`
  border-radius: 10px;
  aspect-ratio: 4 / 3;
  object-fit: cover;
`
